<template>
  <div ref="stickyRef" :class="['compare__header', { 'compare__header--sticky': sticked }]">
    <div class="w-[1200px] mx-auto flex">
      <div class="text-font-1 compare__header--li" :style="`background:${colorsMap[0]}`">
        {{ $t('hui-yuan-quan-yi-dui-bi') }}
      </div>

      <RightsHeader
        v-for="rights in displayRights"
        :key="rights.id"
        class="flex-1 compare__header--li"
        :visible="sticked"
        :rights="rights"
        :colorsMap="colorsMap"
        :account-list="accountList"
      />
    </div>
  </div>
  <div class="w-[1200px] mx-auto">
    <template v-for="(item, index) in compareRights" :key="item.id">
      <IntroCard
        v-if="isCollapse ? true : item.idx === sortData[1]"
        :colorsMap="colorsMap"
        :data="item"
        :vip-icon-idx="!isCollapse ? 0 : index - 1"
      >
      </IntroCard>
    </template>
    <div class="compare__more mt-[30px]" @click="handleCollpase">
      <span class="text-font-1 text-[16px] font-medium hover:text-primary">
        {{ isCollapse ? $t('dian-ji-shou-qi-dingyue') : $t('cha-kan-geng-duo-dingyue') }}
      </span>
      <iconpark-icon
        class="ml-[2px] text-font-1"
        :class="isCollapse ? '' : 'rotate-180'"
        name="arrowup"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { uniq } from 'lodash-es';
import { SHOW_ORG_KEY, USER_LEVEL_KEY, type LoginInfo } from '~/api/interface';
import type { IEquity, IRightsCompare } from '~/api/interface/rights';
import IntroCard from './card.vue';
import RightsHeader from './header.vue';

const props = withDefaults(
  defineProps<{
    showTitle?: boolean;
    rightsList: IEquity[];
    accountList: LoginInfo[];
    compareRights: IRightsCompare[];
    colorsMap: any;
    topHeight?: number;
  }>(),
  {
    showTitle: true,
  },
);

const stickyRef = ref();
const sticked = ref(false);
const isCollapse = ref(false);
const emits = defineEmits(['get']);

const displayRights = computed(() =>
  props.rightsList?.filter(r =>
    [
      USER_LEVEL_KEY.TASTE,
      USER_LEVEL_KEY.PERSONAL_LITE,
      USER_LEVEL_KEY.PERSONAL,
      // USER_LEVEL_KEY.TEAM_LIGHT,
      SHOW_ORG_KEY.ORG_SHOW,
    ].includes(r.rights_type),
  ),
);

const sortData = computed(() => uniq(props.compareRights.map(o => o.idx)));

function handleCollpase() {
  isCollapse.value = !isCollapse.value;
}

const { y } = useElementBounding(stickyRef);

watch(
  () => y.value,
  _y => {
    emits('get');

    sticked.value = _y <= (props.topHeight || 0);
  },
);

// const initContact = () => showDynamicContact(PositionCode['有言官套餐网权益页面专属定制']);

// nextTick(() => {
//   if (import.meta.server) {
//     return;
//   }

//   const elContacts = document.querySelectorAll<HTMLAnchorElement>('a.contactUs');

//   for (const alink of elContacts) {
//     alink.removeEventListener('click', initContact);
//     alink.addEventListener('click', initContact);
//   }
// });
</script>

<style lang="scss">
.compare {
  &__header,
  &__content {
    display: flex;
    &--li {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      text-align: center;

      &:first-child {
        justify-content: flex-start;
        padding-left: 30px;
        width: 220px;
        text-align: left;
      }
      &:not(:first-child) {
        flex: 1;
      }
    }
  }
  &__header {
    position: sticky;
    top: 0;
    border-top: 1px solid var(--back-5);
    border-bottom: 1px solid var(--back-5);
    background-color: var(--back-1);
    z-index: 1;
    width: 1200px;
    margin: 0 auto;
    &--li {
      font-size: 16px;
      line-height: 60px;
      font-weight: 600;
      transition: all 0.2s ease-in-out;
    }
    .sub-btn {
      font-weight: 600;
    }
    .sub-btn-disabled {
      cursor: default;
      opacity: 0.3;
    }
    &--sticky {
      z-index: 1;
      box-shadow: 0px 20px 20px 0px #00000014;
      padding-top: 24px;
      padding-bottom: 28px;
      width: 100%;
      li {
        line-height: 46px;
      }
    }
  }
  &__content {
    background: var(--back-0);
    &:not(:last-child) {
      border-bottom: 1px solid var(--back-5);
    }
    li {
      padding: 20px 0;
      min-height: 36px;
      text-align: center;
      font-size: 14px;
      line-height: 18px;
    }
  }
  &__more {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    line-height: 24px;
    text-align: center;
    font-size: 14px;
    cursor: pointer;
  }
}
</style>
